import DatasetIcon from '../core/icons/Dataset';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { ENTITLEMENTS } from '../application-core/constants';
import SlatInner from '../core/SlatInner';
import { globalStyles as styles } from '../core/style/gstheme';
import { checkResourceEntitlements } from '../core/utils/utils';
import { STATUS_ACCEPTED, STATUS_REJECTED } from '../core/utils/constants';

class IsolatedResourceSlat extends React.Component {

    state = {
        active: false
    };

    setActive(isActive) {
        this.setState({ active: isActive });
    }

    render() {

        const { data, onSelect, classes, defaultLang, viewLang, activeResource, addToDataset, icon, useWorkflow, datasetIRI } = this.props;
        const isReadOnly = checkResourceEntitlements(data, ENTITLEMENTS.EDIT_DATASET)
            || (useWorkflow && "status" in data && (data.status[0] === STATUS_ACCEPTED || data.status[0] === STATUS_REJECTED));;

        let label = data.id;
        const displayLang = viewLang && data.label && data.label[viewLang] ?
            viewLang
            :
            data.label && data.label[defaultLang] ?
                defaultLang
                :
                "und";

        if (data.label && data.label[displayLang]) {
            label = Array.isArray(data.label[displayLang]) ?
                [...data.label[displayLang]].sort().join(" AND ") : data.label[displayLang];
        }

        const notInDataset = datasetIRI && (!data.inDataset || data.inDataset.length === 0 || !data.inDataset.includes(datasetIRI));

        const fallbackLang = (viewLang && viewLang !== defaultLang && displayLang === defaultLang)
            || (displayLang === defaultLang && (!data.label || !data.label[defaultLang]))
            || (displayLang === "und" && viewLang !== "und" && defaultLang !== "und")
            || label === data.id;

        let title = label;

        return (
            <div>
                <span className={classes.slatIcon}>
                    {icon}
                </span>
                <SlatInner
                    show={!isReadOnly && !data.pendingDeletion && this.state.active}
                    title={title}
                    displayLang={displayLang}    
                    workflowStatus={useWorkflow && "status" in data ? data.status[0] : undefined}
                    deprecated={data.deprecated}
                    notInComponent={notInDataset}
                    selected={activeResource === data.id}
                    fallbackLang={fallbackLang}
                    viewLang={viewLang}
                    titleTree={[]}
                    onClick={(e) => onSelect(data.id, e)}
                    onActivate={() => this.setActive(true)}
                    hasChildren={!isReadOnly && notInDataset && !data.deprecated && datasetIRI && addToDataset ? true : false}
                    onDeactivate={() => this.setActive(false)}>
                    {!isReadOnly && notInDataset && !data.deprecated && datasetIRI && addToDataset &&
                        <Tooltip title="Add to dataset"
                            onClick={() => addToDataset(data.id)}>
                            <IconButton data-test="add-to-dataset" className={classes.smallIconButton} style={{ color: 'white' }}>
                                <DatasetIcon />
                            </IconButton>
                        </Tooltip>
                    }
                </SlatInner>
            </div >
        );
    }
}


IsolatedResourceSlat.propTypes = {
    data: PropTypes.object.isRequired,
    icon: PropTypes.object,
    viewLang: PropTypes.string,
    useWorkflow: PropTypes.bool,
    isOver: PropTypes.bool,
    datasetIRI: PropTypes.string,
    addToDataset: PropTypes.func,
    position: PropTypes.number,
    activeResource: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(IsolatedResourceSlat));